
import { Component, mixins } from 'nuxt-property-decorator';
import {
  TextImageBlockModel,
  contentBlockImageSizeModifiersMap,
  contentBlockImagePositionModifiersMap,
  contentBlockTextVerticalAlignmentModifiersMap,
} from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import ContentBlockMixin from '../ContentBlockMixin';
import ContentBlockImage from './ContentBlockImage.vue';
import ContentBlockButton from './ContentBlockButton.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockImage,
    ContentBlockButton,
  },
})
export default class TextImageBlock extends mixins(ContentBlockMixin<TextImageBlockModel>) {
  get blockClassNames(): string[] {
    return [
      contentBlockImageSizeModifiersMap[this.settings.image.size],
      contentBlockImagePositionModifiersMap[this.settings.image.position],
      contentBlockTextVerticalAlignmentModifiersMap[this.settings.textVerticalAlignment],
    ];
  }
}
